import type { SVGProps } from 'react';
export const List = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M6.08 6c0-.41.32-.75.72-.75h9.49c.4 0 .71.34.71.75s-.32.75-.71.75h-9.5A.73.73 0 0 1 6.1 6m0 4c0-.41.32-.75.72-.75h9.49c.4 0 .71.34.71.75s-.32.75-.71.75h-9.5a.73.73 0 0 1-.7-.75m0 4c0-.41.32-.75.72-.75h9.49c.4 0 .71.34.71.75s-.32.75-.71.75h-9.5a.73.73 0 0 1-.7-.75"
      clipRule="evenodd"
    />
    <path d="M3.95 7c.52 0 .95-.45.95-1s-.43-1-.95-1A1 1 0 0 0 3 6c0 .55.42 1 .95 1" />
    <path d="M3.95 15c.52 0 .95-.45.95-1s-.43-1-.95-1A1 1 0 0 0 3 14c0 .55.42 1 .95 1" />
    <path d="M3.95 11c.52 0 .95-.45.95-1s-.43-1-.95-1A1 1 0 0 0 3 10c0 .55.42 1 .95 1" />
  </svg>
);
